// extracted by mini-css-extract-plugin
export default {"hiddenInput":"ErrorContainer_hiddenInput__FOt0D"};